import React from "react";
import { FaDesktop, FaUser, FaEye, FaHandshake } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./IconosInformativos.css";

export default function IconosInformativos() {
  const { t } = useTranslation();
  return (
    <div className="iconos-informativos">
      <div className="iconos-row">
        <div className="icono-col">
          <FaDesktop className="icono-info" />
          <div className="icono-label">{t("iconos_informativos.item1")}</div>
        </div>
        <div className="icono-col">
          <FaUser className="icono-info" />
          <div className="icono-label">{t("iconos_informativos.item2")}</div>
        </div>
        <div className="icono-col">
          <FaEye className="icono-info" />
          <div className="icono-label">{t("iconos_informativos.item3")}</div>
        </div>
        <div className="icono-col">
          <FaHandshake className="icono-info" />
          <div className="icono-label">{t("iconos_informativos.item4")}</div>
        </div>
      </div>
      <div className="iconos-texto"></div>
    </div>
  );
}
